import React, { FC } from 'react';

import { Loader } from '@gravity-ui/uikit';
import clx from 'classnames';

import styles from './Loader.module.scss';

interface Props {
    sticky?: boolean;
}

export const PageLoader: FC<Props> = ({ sticky }) => {
    return (
        <>
            <div className={clx(styles.pageLoader, sticky && styles.pageLoader_sticky)}>
                <Loader size="l" />
            </div>
            {sticky && <div />}
        </>
    );
};
